import service from '@/api/periodical';
import {handleError} from "../generators/helpers";

export const state = {
    service: service('newsletters/periodical'),
    queueDateLoading: false,
    queueDates: [],
    periodicalId: null
};

export const mutations = {
    'SET_LOADING': function (state, loading = false) {
        state.queueDateLoading = loading;
    },
    'SET_QUEUE_DATES': function (state, data = []) {
        state.queueDates = data;
    },
    'ADD_QUEUE_DATE': function (state, data = {}) {
        const arr = JSON.partse(JSON.stringify(state.queueDates));

        arr.push(data);

        state.queueDates = arr;
    },
    'UPDATE_QUEUE_DATE': function (state, data = {}) {
        const arr = JSON.partse(JSON.stringify(state.queueDates));

        const index = arr.findIndex(item => item.id === data.id);

        if (index !== -1) {
            arr[index] = Object.assign(arr[index], data);
        }

        state.queueDates = arr;
    }
};

export const getters = {
    queueDateLoading: (state) => {
        return !!state.queueDateLoading;
    },
    queueDates: (state) => {
        return JSON.parse(JSON.stringify(state.queueDates));
    },
};

export const actions = {
    queueDates: function ({commit, state}, {id, filters}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        return state.service.queueDates(id, filters).then(response => {
            commit('SET_QUEUE_DATES', response.data);
            commit('SET_ERRORS', {});
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        });
    },

    createQueueDate: function ({commit, state}, {id, data}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        return state.service.createQueueDate(id, data).then(response => {
            commit('ADD_QUEUE_DATE', response.data);
            commit('SET_ERRORS', {});
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        });
    },

    updateQueueDate: function ({commit, state}, {id, data}) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        if (id !== state.periodicalId) {
            return false;
        }

        commit('UPDATE_QUEUE_DATE', data);

        return true;
    },
};